import { makeStyles } from '@material-ui/core/styles';
// import powerYourRestaurantWithPOS from "../assets/landing-home-power_your_restaurant_with_POS.png";
import checkedIcon from "../assets/home_page_checked_icon.png";

const styles = theme => ({
  downloadContainer: {
    paddingTop: 60,
    // backgroundImage: `url(${powerYourRestaurantWithPOS})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '366px 314px',
    backgroundPosition: 'right bottom',
    minHeight: 520,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '0 0 60px 0',
      backgroundImage: 'none',
      justifyContent: 'center'
    }


  },
  featuredImageContainer: {
    // display: 'none',
    position: 'absolute',
    bottom: '00px',
    right: 0,
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      position: 'static',
      marginTop: '10px',
      bottom: 'unset',
      right: 'unset',
    }
  },
  limitedWidth: {
    maxWidth: 1024,
  },
  phone: {
    width: '120%',
    marginLeft: '-10%'
  },
  subtitleText: {
    color: '#9f9f9f'
  },
  textMe: {
    [theme.breakpoints.down('sm')]: {
      marginTop: 20,
      width: '100%'
    }
  },

  posFeaturePoint: {
    color: '#1D1B2E',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',

    backgroundImage: `url(${checkedIcon})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '28px 28px',
    backgroundPosition: 'left center',
    paddingLeft: '40px',
    margin: '4px 0 ',
  }
})

export default makeStyles(styles)
